const metNeeds = [
    { set:'met', category: 'Esperanza', name: 'Alentad@' },
    { set:'met', category: 'Esperanza', name: 'Esperanzad@' },
    { set:'met', category: 'Esperanza', name: 'Espectante' },
    { set:'met', category: 'Esperanza', name: 'Optimista' },

    { set:'met', category: 'Confianza', name: 'Capaz'},
    { set:'met', category: 'Confianza', name: 'Confiad@'},
    { set:'met', category: 'Confianza', name: 'Fuerte'},
    { set:'met', category: 'Confianza', name: 'Illusionad@'},
    { set:'met', category: 'Confianza', name: 'Orgullos@'},
    { set:'met', category: 'Confianza', name: 'Recepetiv@'},
    { set:'met', category: 'Confianza', name: 'Segur@'},

    { set:'met', category: 'Afecto', name: 'Afectuos@'},
    { set:'met', category: 'Afecto', name: 'Amoros@'},
    { set:'met', category: 'Afecto', name: 'Cariños@'},
    { set:'met', category: 'Afecto', name: 'Compasiv@'},
    { set:'met', category: 'Afecto', name: 'Comprensiv@'},
    { set:'met', category: 'Afecto', name: 'Simpátic@'},
    { set:'met', category: 'Afecto', name: 'Tiern@'},

    { set:'met', category: 'Euforia', name: 'Eufóric@'},
    { set:'met', category: 'Euforia', name: 'Exultante'},
    { set:'met', category: 'Euforia', name: 'Efusiv@'},

    { set:'met', category: 'Inspiración', name: 'Impresionad@'},
    { set:'met', category: 'Inspiración', name: 'Inspirad@'},
    { set:'met', category: 'Inspiración', name: 'Maravillad@'},
    { set:'met', category: 'Inspiración', name: 'Parad@'},

    { set:'met', category: 'Interés', name: 'Abiert@'},
    { set:'met', category: 'Interés', name: 'Atent@'},
    { set:'met', category: 'Interés', name: 'Atraíd@'},
    { set:'met', category: 'Interés', name: 'Comprometid@'},
    { set:'met', category: 'Interés', name: 'Curios@'},
    { set:'met', category: 'Interés', name: 'Decidid@'},
    { set:'met', category: 'Interés', name: 'Dispuest@'},
    { set:'met', category: 'Interés', name: 'Inspirad@'},
    { set:'met', category: 'Interés', name: 'Interesad@'},
    { set:'met', category: 'Interés', name: 'Intrigad@'},
    { set:'met', category: 'Interés', name: 'Involucrad@'},
    { set:'met', category: 'Interés', name: 'Motivad@'},

    { set:'met', category: 'Descanso', name: 'Descansad@'},
    { set:'met', category: 'Descanso', name: 'Refrescad@'},
    { set:'met', category: 'Descanso', name: 'Renovad@'},
    { set:'met', category: 'Descanso', name: 'Reposad@'},
    { set:'met', category: 'Descanso', name: 'Restaurad@'},

    { set:'met', category: 'Entusiasmo', name: 'Animad@'},
    { set:'met', category: 'Entusiasmo', name: 'Apasionad@'},
    { set:'met', category: 'Entusiasmo', name: 'Entusiasmad@'},
    { set:'met', category: 'Entusiasmo', name: 'Estimulad@'},
    { set:'met', category: 'Entusiasmo', name: 'Exitad@'},
    { set:'met', category: 'Entusiasmo', name: 'Fascinad@'},
    { set:'met', category: 'Entusiasmo', name: 'Illusionad@'},
    { set:'met', category: 'Entusiasmo', name: 'Impresionad@'},
    { set:'met', category: 'Entusiasmo', name: 'Sorprendid@'},

    { set:'met', category: 'Paz', name: 'Aliviad@'},
    { set:'met', category: 'Paz', name: 'Sosegad@'},
    { set:'met', category: 'Paz', name: 'Calmad@'},
    { set:'met', category: 'Paz', name: 'Centrad@'},
    { set:'met', category: 'Paz', name: 'Cercan@'},
    { set:'met', category: 'Paz', name: 'Cómod@'},
    { set:'met', category: 'Paz', name: 'Content@'},
    { set:'met', category: 'Paz', name: 'Desahogad@'},
    { set:'met', category: 'Paz', name: 'Despreocupad@'},
    { set:'met', category: 'Paz', name: 'Lúcid@'},
    { set:'met', category: 'Paz', name: 'Plácid@'},
    { set:'met', category: 'Paz', name: 'Realizad@'},
    { set:'met', category: 'Paz', name: 'Relajad@'},
    { set:'met', category: 'Paz', name: 'Satisfech@'},

    { set:'met', category: 'Felicidad', name: 'Alegre'},
    { set:'met', category: 'Felicidad', name: 'Complacid@'},
    { set:'met', category: 'Felicidad', name: 'Feliz'},
    { set:'met', category: 'Felicidad', name: 'Gozos@'},

    { set:'met', category: 'Gratitud', name: 'Agradecid@'},
    { set:'met', category: 'Gratitud', name: 'Conmovid@'},
    { set:'met', category: 'Gratitud', name: 'Emocionad@'},
    { set:'met', category: 'Gratitud', name: 'Generos@'},

];

const unmetNeeds = [
    { set:'unmet', category:'Anhelo', name:'Añorad@'},
    { set:'unmet', category:'Anhelo', name:'Celos@'},
    { set:'unmet', category:'Anhelo', name:'Deseos@'},
    { set:'unmet', category:'Anhelo', name:'Envidios@'},
    { set:'unmet', category:'Anhelo', name:'Melancólic@'},
    { set:'unmet', category:'Anhelo', name:'Nostálgic@'},
    { set:'unmet', category:'Anhelo', name:'Sol@'},

    { set:'unmet', category:'Aversión', name:'Asco'},
    { set:'unmet', category:'Aversión', name:'Horrorizad@'},
    { set:'unmet', category:'Aversión', name:'Desprecio'},
    { set:'unmet', category:'Aversión', name:'Odio'},
    { set:'unmet', category:'Aversión', name:'Repugnad@'},

    { set:'unmet', category:'Desconexión', name:'Aburrid@'},
    { set:'unmet', category:'Desconexión', name:'Afectad@'},
    { set:'unmet', category:'Desconexión', name:'Aislad@'},
    { set:'unmet', category:'Desconexión', name:'Apátic@'},
    { set:'unmet', category:'Desconexión', name:'Desconectad@'},
    { set:'unmet', category:'Desconexión', name:'Desidios@'},
    { set:'unmet', category:'Desconexión', name:'Distante'},
    { set:'unmet', category:'Desconexión', name:'Frí@'},
    { set:'unmet', category:'Desconexión', name:'Indiferente'},
    { set:'unmet', category:'Desconexión', name:'Reprochad@'},

    { set:'unmet', category:'Enfadado', name:'Disgustad@'},
    { set:'unmet', category:'Enfadado', name:'Enfadad@'},
    { set:'unmet', category:'Enfadado', name:'Furios@'},
    { set:'unmet', category:'Enfadado', name:'Indignad@'},
    { set:'unmet', category:'Enfadado', name:'Molest@'},
    { set:'unmet', category:'Enfadado', name:'Resenti@'},

    { set:'unmet', category:'Tensión', name:'Ansios@'},
    { set:'unmet', category:'Tensión', name:'Conmocionad@'},
    { set:'unmet', category:'Tensión', name:'Desbordad@'},
    { set:'unmet', category:'Tensión', name:'Estresad@'},
    { set:'unmet', category:'Tensión', name:'Irritable'},
    { set:'unmet', category:'Tensión', name:'Nervios@'},
    { set:'unmet', category:'Tensión', name:'Sobrecarg@'},
    { set:'unmet', category:'Tensión', name:'Sobrepasad@'},
    { set:'unmet', category:'Tensión', name:'Tens@'},

    { set:'unmet', category:'Miedo', name:'Acongojad@'},
    { set:'unmet', category:'Miedo', name:'Asustad@'},
    { set:'unmet', category:'Miedo', name:'Atemorizad@'},
    { set:'unmet', category:'Miedo', name:'Aterrorizad@'},
    { set:'unmet', category:'Miedo', name:'Desconfiad@'},
    { set:'unmet', category:'Miedo', name:'Preocupad@'},

    { set:'unmet', category:'Cansancio', name:'Abatid@'},
    { set:'unmet', category:'Cansancio', name:'Agotad@'},
    { set:'unmet', category:'Cansancio', name:'Cansad@'},
    { set:'unmet', category:'Cansancio', name:'Débil'},
    { set:'unmet', category:'Cansancio', name:'Dolorid@'},
    { set:'unmet', category:'Cansancio', name:'Fatigad@'},
    { set:'unmet', category:'Cansancio', name:'Afligad@'},
    { set:'unmet', category:'Cansancio', name:'Angustiad@'},
    { set:'unmet', category:'Cansancio', name:'Desconsolad@'},
    { set:'unmet', category:'Cansancio', name:'Deshech@'},

    { set:'unmet', category:'Confusión', name:'Bloquead@'},
    { set:'unmet', category:'Confusión', name:'Confus@'},
    { set:'unmet', category:'Confusión', name:'Desorientad@'},
    { set:'unmet', category:'Confusión', name:'Dividid@'},
    { set:'unmet', category:'Confusión', name:'Dudos@'},
    { set:'unmet', category:'Confusión', name:'Escéptic@'},
    { set:'unmet', category:'Confusión', name:'Indescis@'},
    { set:'unmet', category:'Confusión', name:'Pensativ@'},
    { set:'unmet', category:'Confusión', name:'Perdid@'},
    { set:'unmet', category:'Confusión', name:'Perplej@'},
    { set:'unmet', category:'Confusión', name:'Vacilante'},

    { set:'unmet', category:'Inquietud', name:'Agitad@'},
    { set:'unmet', category:'Inquietud', name:'Agobiad@'},
    { set:'unmet', category:'Inquietud', name:'Alarmad@'},
    { set:'unmet', category:'Inquietud', name:'Arrepetid@'},
    { set:'unmet', category:'Inquietud', name:'Avergonzad@'},
    { set:'unmet', category:'Inquietud', name:'Desconcertad@'},
    { set:'unmet', category:'Inquietud', name:'Escandalizad@'},
    { set:'unmet', category:'Inquietud', name:'Incómod@'},
    { set:'unmet', category:'Inquietud', name:'Inquiet@'},
    { set:'unmet', category:'Inquietud', name:'Intranquil@'},
    { set:'unmet', category:'Inquietud', name:'Preocupad@'},
    { set:'unmet', category:'Inquietud', name:'Sobresaltad@'},
    { set:'unmet', category:'Inquietud', name:'Sorprendid@'},

    { set:'unmet', category:'Irritación', name:'Consternad@'},
    { set:'unmet', category:'Irritación', name:'Frustrad@'},
    { set:'unmet', category:'Irritación', name:'Impaciente'},
    { set:'unmet', category:'Irritación', name:'Irritad@'},
    { set:'unmet', category:'Irritación', name:'Malhumorad@'},
    { set:'unmet', category:'Irritación', name:'Molest@'},

    { set:'unmet', category:'Vulnerabilidad', name:'Frágil'},
    { set:'unmet', category:'Vulnerabilidad', name:'Impotente'},
    { set:'unmet', category:'Vulnerabilidad', name:'Insegur@'},
    { set:'unmet', category:'Vulnerabilidad', name:'Sensible'},
    { set:'unmet', category:'Vulnerabilidad', name:'Tímid@'},
    { set:'unmet', category:'Vulnerabilidad', name:'Vulnerable'},

    { set:'unmet', category:'Tristeza', name:'Decepcionad@'},
    { set:'unmet', category:'Tristeza', name:'Deprimid@'},
    { set:'unmet', category:'Tristeza', name:'Desanimad@'},
    { set:'unmet', category:'Tristeza', name:'Desgraciad@'},
    { set:'unmet', category:'Tristeza', name:'Desilusionad@'},
    { set:'unmet', category:'Tristeza', name:'Infeliz'},
    { set:'unmet', category:'Tristeza', name:'Triste'},
]

const moods = [
    ...metNeeds,
    ...unmetNeeds,
];

export default moods;
